import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import * as styles from './ContentPlaceholder.css';
import { dt } from '../../helpers/Utils/GetTailwindToken';

const cx = classNames.bind(styles);

const ContentPlaceholder = ({
    mask, // masking block to cover the background (and appears like the background)
    miniPDPMaskStyle, // for loading minipdp after colorcarousel feature being added
}) => {
    const defaultMaskStyle = dt(['h-auto', 'w-full', 'leading-[0]', 'placeHolderShimmer']);
    const defaultMask = <div className={cx('defaultMask', defaultMaskStyle)} />;
    const renderChild = () => (
        <div className={cx('contentPlaceholder', defaultMaskStyle, miniPDPMaskStyle)}>
            {mask || defaultMask}
        </div>
    );

    return <>{renderChild()}</>;
};

ContentPlaceholder.propTypes = {
    mask: PropTypes.object,
    miniPDPMaskStyle: PropTypes.object,
};

ContentPlaceholder.defaultProps = {
    mask: null,
    miniPDPMaskStyle: null,
};

export default ContentPlaceholder;
